import script from "./OrderForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderForm.vue?vue&type=script&setup=true&lang=js"

import "./OrderForm.vue?vue&type=style&index=0&id=05700a88&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05700a88"]])

export default __exports__